import { render, staticRenderFns } from "./AppWebSettingsEdit.vue?vue&type=template&id=428eb137"
import script from "./AppWebSettingsEdit.vue?vue&type=script&lang=js"
export * from "./AppWebSettingsEdit.vue?vue&type=script&lang=js"
import style0 from "./AppWebSettingsEdit.vue?vue&type=style&index=0&id=428eb137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports